import { I18n } from '@app/i18n/strings-keys';
import { IPdfTableHeader } from '@app/shared/common/make-pdf/pdf-table-header.type';
import { TextAlign, TotalHeader } from '../entities';

/**
 * @deprecated use I18n.Forms.GridForm.ItemName etc directly
 */
export enum TRANSFER_PDF_HEADER_NAMES {
  ItemName = 'Item Name',
  Par = 'Par',
  DepartmentCode = 'Department Code',
  GlAccount = 'GL Account',
  From = 'QOH - From',
  To = 'QOH - To',
  TransferUnit = 'Transfer Unit',
  QuantityRequested = 'Qty Requested',
  UnitCost = 'Unit Cost',
  TotalCost = 'Total Cost',
  ReceivedCost = 'Received Cost',
  RequestCost = 'Request Cost',
  QuantityReceived = 'Qty Received',
  NotReceived = 'Qty Not Received',
  SiteID = 'Site ID',
  SiteName = 'Site Name',
  Tags = 'Tags',
  QuantityReversed = 'Qty Reversed',
  ParQty = 'PAR Qty',
}

export enum TRANSFER_PDF_HEADER_VALUES {
  ItemName = 'item_name',
  Name = 'name',
  Par = 'par',
  DepartmentCode = 'department_code',
  GlAccount = 'gl_account_name',
  From = 'qoh_from',
  To = 'qoh_to',
  TransferUnit = 'transfer_unit',
  Quantity = 'count',
  InitialQuantity = 'initial_count',
  UnitCost = 'item_cost',
  TotalCost = 'total_cost',
  QuantityReceivedEmpty = 'quantity_received_empty',
  QuantityReceived = 'quantity_received',
  Measures = 'measures',
  QuantityRequestedEmpty = 'quantity_request_empty',
  QuantityRequest = 'quantity_request',
  NotReceived = 'not_received',
  StoreNumber = 'store_number',
  MetaData = 'metadata',
  isChargeable = 'is_chargeable',
  ParQty = 'par_qty',
  QtyPulled = 'qty_pulled',
}

export enum TRANSFER_PDF_SUMMARY_NAMES {
  TransferType = 'Transfer Type',
  From = 'From',
  To = 'To',
  Status = 'Status',
  TransferDate = 'Transfer Date',
  Event = 'Event',
  Transfer_Group_Name = 'Transfer Group Name',
  Source = 'Source',
}

export const TRANSFER_PDF_HEADERS: IPdfTableHeader[] = [
  {
    title: I18n.Forms.GridForm.ItemName,
    path: TRANSFER_PDF_HEADER_VALUES.ItemName,
    required: true,
  },
  {
    title: I18n.Forms.GridForm.GLAccount,
    path: TRANSFER_PDF_HEADER_VALUES.GlAccount,
  },
  {
    title: I18n.Forms.TransferForm.QOHFrom,
    path: TRANSFER_PDF_HEADER_VALUES.From,
  },
  {
    title: I18n.Forms.TransferForm.QOHTo,
    path: TRANSFER_PDF_HEADER_VALUES.To,
  },
  {
    title: I18n.Forms.TransferForm.TransferUnit,
    path: TRANSFER_PDF_HEADER_VALUES.TransferUnit,
    required: true,
  },
  {
    title: I18n.Forms.TransferForm.QtyRequested,
    path: TRANSFER_PDF_HEADER_VALUES.Quantity,
    required: true,
  },
  {
    title: I18n.Forms.GridForm.UnitCost,
    path: TRANSFER_PDF_HEADER_VALUES.UnitCost,
  },
  {
    title: I18n.Forms.TransferForm.RequestCost,
    path: TRANSFER_PDF_HEADER_VALUES.TotalCost,
  },
  {
    title: I18n.EntityNames.DepartmentCode,
    path: TRANSFER_PDF_HEADER_VALUES.DepartmentCode,
  },
];

export const TRANSFER_PDF_HEADERS_FINAL: IPdfTableHeader[] = [
  {
    title: I18n.Forms.GridForm.ItemName,
    path: TRANSFER_PDF_HEADER_VALUES.ItemName,
    required: true,
  },
  {
    title: I18n.Forms.GridForm.GLAccount,
    path: TRANSFER_PDF_HEADER_VALUES.GlAccount,
  },
  {
    title: I18n.Forms.TransferForm.QOHFrom,
    path: TRANSFER_PDF_HEADER_VALUES.From,
  },
  {
    title: I18n.Forms.TransferForm.QOHTo,
    path: TRANSFER_PDF_HEADER_VALUES.To,
  },
  {
    title: I18n.Forms.TransferForm.TransferUnit,
    path: TRANSFER_PDF_HEADER_VALUES.TransferUnit,
    required: true,
  },
  {
    title: I18n.Forms.TransferForm.QtyRequested,
    path: TRANSFER_PDF_HEADER_VALUES.InitialQuantity,
    required: true,
  },
  {
    title: I18n.Forms.GridForm.UnitCost,
    path: TRANSFER_PDF_HEADER_VALUES.UnitCost,
  },
  {
    title: I18n.Forms.TransferForm.QtyReceived,
    path: TRANSFER_PDF_HEADER_VALUES.Quantity,
    required: true,
  },
  {
    title: I18n.Forms.TransferForm.ReceivedCost,
    path: TRANSFER_PDF_HEADER_VALUES.TotalCost,
  },
  {
    title: I18n.EntityNames.DepartmentCode,
    path: TRANSFER_PDF_HEADER_VALUES.DepartmentCode,
  },
];

export const TRANSFER_PDF_EMPTY_HEADERS_FOR_OPEN_STATUS: IPdfTableHeader[] = [
  {
    title: I18n.Forms.GridForm.ItemName,
    path: TRANSFER_PDF_HEADER_VALUES.ItemName,
    required: true,
  },
  {
    title: I18n.Forms.GridForm.GLAccount,
    path: TRANSFER_PDF_HEADER_VALUES.GlAccount,
  },
  {
    title: I18n.Forms.TransferForm.QOHFrom,
    path: TRANSFER_PDF_HEADER_VALUES.From,
    required: true,
  },
  {
    title: I18n.Forms.TransferForm.QOHTo,
    path: TRANSFER_PDF_HEADER_VALUES.To,
    required: true,
  },
  {
    title: I18n.Forms.TransferForm.TransferUnit,
    path: TRANSFER_PDF_HEADER_VALUES.Measures,
    required: true,
  },
  {
    title: I18n.Forms.GridForm.UnitCost,
    path: TRANSFER_PDF_HEADER_VALUES.UnitCost,
  },
  {
    title: I18n.Forms.TransferForm.QtyRequested,
    path: TRANSFER_PDF_HEADER_VALUES.QuantityRequestedEmpty,
    required: true,
  },
  {
    title: I18n.EntityNames.DepartmentCode,
    path: TRANSFER_PDF_HEADER_VALUES.DepartmentCode,
  },
];

export const TRANSFER_PDF_EMPTY_HEADERS: IPdfTableHeader[] = [
  {
    title: I18n.Forms.GridForm.ItemName,
    path: TRANSFER_PDF_HEADER_VALUES.ItemName,
    required: true,
  },
  {
    title: I18n.Forms.GridForm.GLAccount,
    path: TRANSFER_PDF_HEADER_VALUES.GlAccount,
  },
  {
    title: I18n.Forms.TransferForm.QOHFrom,
    path: TRANSFER_PDF_HEADER_VALUES.From,
    required: true,
  },
  {
    title: I18n.Forms.TransferForm.QOHTo,
    path: TRANSFER_PDF_HEADER_VALUES.To,
    required: true,
  },
  {
    title: I18n.Forms.TransferForm.TransferUnit,
    path: TRANSFER_PDF_HEADER_VALUES.TransferUnit,
    required: true,
  },
  {
    title: I18n.Forms.GridForm.UnitCost,
    path: TRANSFER_PDF_HEADER_VALUES.UnitCost,
  },
  {
    title: I18n.Forms.TransferForm.QtyRequested,
    path: TRANSFER_PDF_HEADER_VALUES.InitialQuantity,
    required: true,
  },
  {
    title: I18n.Forms.TransferForm.RequestCost,
    path: TRANSFER_PDF_HEADER_VALUES.TotalCost,
  },
  {
    title: I18n.Forms.TransferForm.QtyReceived,
    path: TRANSFER_PDF_HEADER_VALUES.QuantityReceivedEmpty,
    required: true,
  },
  {
    title: I18n.EntityNames.DepartmentCode,
    path: TRANSFER_PDF_HEADER_VALUES.DepartmentCode,
  },
];

export const TRANSFER_PDF_TOTAL_HEADERS: TotalHeader[] = [
  {
    text: I18n.EntityNames.DepartmentCode,
  },
  {
    text: I18n.Forms.GridForm.GLAccount,
  },
  {
    text: I18n.Forms.TransferForm.QtyRequested,
    textAlign: TextAlign.RIGHT,
  },
  {
    text: I18n.Forms.TransferForm.RequestCost,
    textAlign: TextAlign.RIGHT,
  },
];

export const TRANSFER_PDF_TOTAL_HEADERS_FINAL: TotalHeader[] = [
  {
    text: I18n.EntityNames.DepartmentCode,
  },
  {
    text: I18n.Forms.GridForm.GLAccount,
  },
  {
    text: I18n.Forms.TransferForm.QtyRequested,
    textAlign: TextAlign.RIGHT,
  },
  {
    text: I18n.Forms.TransferForm.QtyReceived,
    textAlign: TextAlign.RIGHT,
  },
  {
    text: I18n.Forms.TransferForm.ReceivedCost,
    textAlign: TextAlign.RIGHT,
  },
];

export const TRANSFER_PDF_TOTAL_HEADERS_EMPTY_FOR_OPEN_STATUS: TotalHeader[] = [
  {
    text: I18n.EntityNames.DepartmentCode,
  },
  {
    text: I18n.Forms.GridForm.GLAccount,
  },
  {
    text: I18n.Forms.TransferForm.QtyRequested,
    textAlign: TextAlign.RIGHT,
  },
];

export const TRANSFER_PDF_TOTAL_HEADERS_EMPTY: TotalHeader[] = [
  {
    text: I18n.EntityNames.DepartmentCode,
  },
  {
    text: I18n.Forms.GridForm.GLAccount,
  },
  {
    text: I18n.Forms.TransferForm.QtyRequested,
    textAlign: TextAlign.RIGHT,
  },
  {
    text: I18n.Forms.TransferForm.RequestCost,
    textAlign: TextAlign.RIGHT,
  },
  {
    text: I18n.Forms.TransferForm.QtyReceived,
    textAlign: TextAlign.RIGHT,
  },
];

export const TRANSFER_PAR_QTY_COLUMN_HEADER = {
  title: I18n.Forms.TransferForm.PARQty,
  path: TRANSFER_PDF_HEADER_VALUES.ParQty,
};

export const TRANSFER_QTY_PULLED_COLUMN_HEADER = {
  title: I18n.Forms.TransferForm.QtyPulled,
  path: TRANSFER_PDF_HEADER_VALUES.QtyPulled,
};

export enum TOTALS_CATEGORY {
  normal = 'Normal',
  reversals = 'Reversals',
}
